import { ODSTextField } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';

interface ODSCopyFieldProps {
  id?: string;
  name: string;
  value: string | number;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  helperText?: string;
}

export const ODSCopyField: FC<ODSCopyFieldProps> = ({
  id = '',
  name,
  value,
  label,
  placeholder = '',
  disabled = false,
  helperText = '',
}) => {
  const copyToClipboard = useCopyToClipboard();

  return (
    <ODSTextField
      inputProps={{
        id: id || name,
        type: 'text',
        name: name,
      }}
      placeholderText={placeholder}
      readonly={disabled}
      supportMessageProps={{
        helperText: helperText,
      }}
      value={value}
      labelText={label}
      size='small'
      mode={helperText ? 'error' : 'informative'}
      textFieldIconProps={{
        icon: 'copy-paste-type-standard',
        type: 'buttonContainer',
        buttonProps: {
          label: 'Copy to clipboard',
          buttonIcon: 'copy-paste-type-standard',
        },
        onClick: () => {
          copyToClipboard(value as string);
        },
      }}
      showRightIcon={true}
    />
  );
};
